import set from 'lodash.set';

import { VirtualizedTableState, VirtualizedTableTypes } from './types';
import {
    VIRTUALIZED_TABLE_COLUMNS_SET,
    VIRTUALIZED_TABLE_COLUMN_WIDTH_OFFSET_SET,
    VIRTUALIZED_TABLE_COLUMN_WIDTH_SET,
    VIRTUALIZED_TABLE_ITEMS_SET,
    VIRTUALIZED_TABLE_ITEM_SET,
    VIRTUALIZED_TABLE_ITEMS_DELETE,
    VIRTUALIZED_TABLE_ERRORS_SET,
    VIRTUALIZED_TABLE_ERROR_SET,
    VIRTUALIZED_TABLE_ERROR_REMOVE,
    VIRTUALIZED_TABLE_RESET,
    VIRTUALIZED_TABLE_SUBMIT_HAS_FAILED
} from './constants';

export const initialState: VirtualizedTableState = {
    columnKeys: [],
    columnsKeyedByKey: {},
    columnWidths: {},
    columnWidthOffsets: {},
    itemsKeyedByKey: {},
    errors: {},
    submitHasFailed: false
};

export default function (
    state: VirtualizedTableState = initialState,
    action: VirtualizedTableTypes
): VirtualizedTableState {
    switch (action.type) {
        case VIRTUALIZED_TABLE_COLUMNS_SET: {
            const {
                columnKeys,
                columnsKeyedByKey,
                columnWidths,
                columnWidthOffsets
            } = action.payload;

            return {
                ...state,
                columnKeys,
                columnsKeyedByKey,
                columnWidths,
                columnWidthOffsets
            };
        }
        case VIRTUALIZED_TABLE_COLUMN_WIDTH_OFFSET_SET: {
            const { columnKey, columnWidthOffset } = action.payload;
            return {
                ...state,
                columnWidthOffsets: {
                    ...state.columnWidthOffsets,
                    [columnKey]: columnWidthOffset
                }
            };
        }
        case VIRTUALIZED_TABLE_COLUMN_WIDTH_SET: {
            const { columnKey, columnWidth } = action.payload;
            return {
                ...state,
                columnWidths: {
                    ...state.columnWidths,
                    [columnKey]: columnWidth
                },
                columnWidthOffsets: {
                    ...state.columnWidthOffsets,
                    [columnKey]: 0
                }
            };
        }
        case VIRTUALIZED_TABLE_ITEMS_SET: {
            const { itemsKeyedByKey } = action.payload;
            return {
                ...state,
                itemsKeyedByKey
            };
        }
        case VIRTUALIZED_TABLE_ITEM_SET: {
            const { itemsKeyedByKey } = action.payload;
            return {
                ...state,
                itemsKeyedByKey: {
                    ...state.itemsKeyedByKey,
                    ...itemsKeyedByKey
                }
            };
        }
        case VIRTUALIZED_TABLE_ITEMS_DELETE: {
            const { itemKeys } = action.payload;
            return {
                ...state,
                itemsKeyedByKey: itemKeys.reduce((result, itemKey) => {
                    const items = { ...result };

                    delete items[itemKey];
                    return items;
                }, state.itemsKeyedByKey)
            };
        }
        case VIRTUALIZED_TABLE_ERRORS_SET: {
            const { errors } = action.payload;
            return {
                ...state,
                errors
            };
        }
        case VIRTUALIZED_TABLE_ERROR_SET: {
            const { itemKey, itemField, errorMessage } = action.payload;
            const copy = { ...state };
            set(copy, ['errors', itemKey, itemField], errorMessage);
            return copy;
        }
        case VIRTUALIZED_TABLE_ERROR_REMOVE: {
            const { itemKey, itemField } = action.payload;
            const copy = { ...state };
            set(copy, ['errors', itemKey, itemField], undefined);
            return copy;
        }
        case VIRTUALIZED_TABLE_RESET:
            return initialState;
        case VIRTUALIZED_TABLE_SUBMIT_HAS_FAILED: {
            const { submitHasFailed } = action.payload;

            return {
                ...state,
                submitHasFailed
            };
        }
        default:
            return state;
    }
}
